import { render, staticRenderFns } from "./ChoosePharmaceutical.vue?vue&type=template&id=2688f608"
import script from "./ChoosePharmaceutical.vue?vue&type=script&lang=js"
export * from "./ChoosePharmaceutical.vue?vue&type=script&lang=js"
import style0 from "./ChoosePharmaceutical.vue?vue&type=style&index=0&id=2688f608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports